export default __webpack_public_path__ + "static/media/IMG_HOME_EGRESADOS.977d294c.png";